import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";

import { useSelector } from "react-redux";

import * as authActions from "../../store/actions/authActions";
import PreloaderInner from "./../../components/preloader/loader";

// Stylesheet
import "./NFTCards.css";

// Assets
import avatar from "./../../assets/avatar.png";
import priceEth from "../../assets/eth.svg";
import pricePoly from "../../assets/matic.svg";

import "./style.scss";
import { authFeatureKey, nftFeatureKey } from "../../store/featureKeys";
import { color } from "@mui/system";

function NFTCards({ nfts, length }) {
  const [loader, setLoader] = useState(true);
  const nftData = useSelector((state) => state[nftFeatureKey]);
  useEffect(() => {
    console.log(loader, "loader");
    console.log(nftData, "nftData");
    if (nftData.loading) {
      setLoader(true);
    } else {
      setLoader(false);
    }
    if (nftData.nfts) {
      setLoader(false);
    }
  }, [nftData.loading]);

  // useEffect(() => {
  //   if (!nftData.loading) {
  //     setLoader(false);
  //   }
  // }, [nftData.loading]);

  return (
    <section style={{padding:"0 2vw"}}>
      {loader ? (
        <PreloaderInner />
      ) : (
        <div className="nft-cards-wrapper">
          {nfts && nfts.length > 0 ? (
            nfts.slice(0, length).map((item, index) => {
              return <NFTCard item={item} key={index} />;
            })
          ) : (
            <p
              style={{
                position: "absolute",
                left: "50%",
                transform: "translateX(-50%)",
                color: "#d3aa4b",
              }}
            >
              No NFTs Found
            </p>
          )}
        </div>
      )}
    </section>
  );
}

export default NFTCards;


const NFTCard = ({ item }) => {
  let history = useHistory();
  let dispatch = useDispatch();
  let isHover = false;
  const { currentUser, isConnected, user } = useSelector((state) => {
    return state[authFeatureKey];
  });
  let handleCardClick = (e) => {
    e.preventDefault();
    console.log("handleCardClick -> ");
    history.push(`/explore/${item.ipfsHash}`);
  };
  let [likes, setLikes] = useState(false);

  const isNFTLiked = (docId) => {
    if (isConnected) {
      const isLiked = user.likedNft.find((nft) => nft === docId);
      if (isLiked) return true;
      return false;
    } else {
      return false;
    }
  };
  let likeNft = (docID, e) => {
    e.preventDefault();
    e.stopPropagation();
    if (isConnected) {
      setLikes((prevState) => !prevState);
      if (isNFTLiked(docID)) {
        console.log("alreday liked...... now write the dislike logic here ");
        dispatch(authActions.dislikeCard(docID, currentUser));
      } else {
        dispatch(authActions.likeCard(docID, currentUser));
      }
    }
  };

  let changeBackground = (e) => {
    console.log("==========================CHANGE BG========================", isHover);
    isHover = isHover ? false : true;
  }

  return (
    <div class="nft-card-wrapper nft-card-hover" onClick={handleCardClick}>
      <div className="media-container">
        {item && item.imageUrl && item.imageUrl.indexOf("mp4") > -1 ? (
          <video className="nftImg" src={item.imageUrl} preload="metadata" />
        ) : (
          <img src={item.imageUrl} className="media-item" alt="" />
        )}
      </div>
      <div className="profile-details-wrapper">
        <div className="profile-img">
          {item.userImageURL ? (
            <img src={item.userImageURL} alt="Avatar" />
          ) : (
            <img src={avatar} alt="Avatar" />
          )}
        </div>
        <div className="name-container">
          <div className="full-name">{item.name}</div>
          <div className="username">@{item.username}</div>
        </div>
      </div>
      <div className="nft-card-footer">
        <div className="eth-balance-wrapper">
          {item.chain === "Ethereum" ? (
            <img src={priceEth} alt="price" height="20px" />
          ) : (
            <img src={pricePoly} alt="price" height="20px" />
          )}
          <div className="eth-balance">{item.price}</div>
        </div>
        <div className="heart-icon" onClick={(e) => e.stopPropagation()}>
          {isNFTLiked(item.docID) ? (
            <svg
              onClick={likeNft.bind(this, item.docID)}
              width="21"
              height="21"
              viewBox="0 0 21 21"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M0.411072 9.73728C-0.775056 6.03408 0.611155 1.80139 4.49896 0.548931C6.54401 -0.111012 8.8013 0.2781 10.5015 1.55708C12.1099 0.313474 14.4501 -0.10659 16.4929 0.548931C20.3807 1.80139 21.7757 6.03408 20.5907 9.73728C18.7447 15.6071 10.5015 20.1283 10.5015 20.1283C10.5015 20.1283 2.31905 15.6757 0.411072 9.73728Z"
                className="path-selected"
              />
            </svg>
          ) : (
            <svg
              onClick={likeNft.bind(this, item.docID)}
              width="21"
              height="21"
              viewBox="0 0 21 21"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M0.411072 9.73728C-0.775056 6.03408 0.611155 1.80139 4.49896 0.548931C6.54401 -0.111012 8.8013 0.2781 10.5015 1.55708C12.1099 0.313474 14.4501 -0.10659 16.4929 0.548931C20.3807 1.80139 21.7757 6.03408 20.5907 9.73728C18.7447 15.6071 10.5015 20.1283 10.5015 20.1283C10.5015 20.1283 2.31905 15.6757 0.411072 9.73728Z"
                className="path-not-selected"
              />
            </svg>
          )}
        </div>
      </div>
    </div>
  );
};
